// ABT header araması: yazarken Shopify'ın suggest.json ucundan ürün ve
// kategori önerisi getirir, kutunun altında listeler. Kutu boşken son
// aramaları ve öne çıkan kategorileri gösterir. Tema modalını açmaz.

(() => {
  const kap = document.querySelector('.abt-header-ara');
  if (!kap) return;

  const input = kap.querySelector('input[name="q"]');
  const liste = document.createElement('div');
  liste.className = 'abt-ara-sonuc';
  liste.hidden = true;
  liste.setAttribute('role', 'listbox');
  kap.appendChild(liste);

  const kok = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const para = new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' });
  const ANAHTAR = 'abt-son-aramalar';
  let zamanlayici;
  let secili = -1;

  let oneriler = [];
  try {
    oneriler = JSON.parse(kap.dataset.oneriler || '[]');
  } catch {
    oneriler = [];
  }

  const kacir = (metin) =>
    String(metin).replace(
      /[&<>"']/g,
      (k) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[k]
    );

  // Eşleşen harfler kalınlaşır. Sorgu regex'e girmeden kaçırılır.
  const vurgula = (metin, q) => {
    const g = kacir(metin);
    const desen = kacir(q).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    if (!desen) return g;
    return g.replace(new RegExp(`(${desen})`, 'gi'), '<mark>$1</mark>');
  };

  const sonAramalar = () => {
    try {
      return JSON.parse(localStorage.getItem(ANAHTAR) || '[]').slice(0, 5);
    } catch {
      return [];
    }
  };

  const aramayiKaydet = (q) => {
    if (!q || q.length < 2) return;
    try {
      const eski = sonAramalar().filter((x) => x.toLowerCase() !== q.toLowerCase());
      localStorage.setItem(ANAHTAR, JSON.stringify([q, ...eski].slice(0, 5)));
    } catch {
      /* gizli sekmede localStorage kapalı olabilir */
    }
  };

  const kapat = () => {
    liste.hidden = true;
    secili = -1;
  };

  const kucult = (url, en) => (url ? `${url}${url.includes('?') ? '&' : '?'}width=${en}` : '');

  const fiyatBlok = (u) => {
    const fiyat = Number(u.price);
    const eski = Number(u.compare_at_price_min || 0);
    const aralik = u.price_min && u.price_max && u.price_min !== u.price_max;
    const indirim = eski > fiyat;

    return (
      `<span class="abt-ara-fiyat${indirim ? ' abt-ara-fiyat--indirim' : ''}">` +
      (indirim ? `<s>${para.format(eski)}</s>` : '') +
      `<b>${para.format(fiyat)}</b>` +
      (aralik ? '<i>başlangıç</i>' : '') +
      '</span>'
    );
  };

  const urunSatiri = (u, q) => {
    const altBilgi = [u.type, u.vendor].filter(Boolean).join(' · ');
    return `
      <a class="abt-ara-satir${u.available === false ? ' abt-ara-satir--tukendi' : ''}" href="${u.url}" role="option">
        <span class="abt-ara-foto">${
          u.featured_image && u.featured_image.url
            ? `<img src="${kucult(u.featured_image.url, 104)}" alt="" loading="lazy">`
            : ''
        }</span>
        <span class="abt-ara-metin">
          <span class="abt-ara-ad">${vurgula(u.title, q)}</span>
          ${altBilgi ? `<span class="abt-ara-alt">${kacir(altBilgi)}</span>` : ''}
        </span>
        ${u.available === false ? '<span class="abt-ara-rozet">Tükendi</span>' : fiyatBlok(u)}
      </a>`;
  };

  const kategoriSatiri = (k, q) => `
    <a class="abt-ara-kategori" href="${k.url}" role="option">
      <span class="abt-ara-ad">${vurgula(k.title || k.ad, q || '')}</span>
      ${k.adet != null ? `<span class="abt-ara-adet">${k.adet} ürün</span>` : ''}
      <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8h9M8.5 4.5L12 8l-3.5 3.5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </a>`;

  function baslangicPaneli() {
    const son = sonAramalar();
    const sonBlok = son.length
      ? '<p class="abt-ara-baslik">Son aramalar</p>' +
        son
          .map(
            (q) => `
        <a class="abt-ara-kategori abt-ara-kategori--sorgu" href="${kok}search?q=${encodeURIComponent(q)}" role="option">
          <span class="abt-ara-ad">${kacir(q)}</span>
          <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8h9M8.5 4.5L12 8l-3.5 3.5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </a>`
          )
          .join('')
      : '';

    const oneriBlok = oneriler.length
      ? '<p class="abt-ara-baslik">Öne çıkan kategoriler</p>' +
        oneriler.map((k) => kategoriSatiri(k, '')).join('')
      : '';

    if (!sonBlok && !oneriBlok) return false;
    liste.innerHTML = sonBlok + oneriBlok;
    liste.hidden = false;
    secili = -1;
    return true;
  }

  async function ara(q) {
    const url =
      `${kok}search/suggest.json?q=${encodeURIComponent(q)}` +
      '&resources[type]=product,collection&resources[limit]=6';
    const yanit = await fetch(url);
    if (!yanit.ok) throw new Error(yanit.status);
    const { resources } = await yanit.json();
    return {
      urunler: resources.results.products || [],
      kategoriler: resources.results.collections || [],
    };
  }

  function bas({ urunler, kategoriler }, q) {
    if (!urunler.length && !kategoriler.length) {
      liste.innerHTML =
        `<p class="abt-ara-bos">"${kacir(q)}" için sonuç yok.</p>` +
        (oneriler.length
          ? '<p class="abt-ara-baslik">Bunlara bakın</p>' +
            oneriler.map((k) => kategoriSatiri(k, '')).join('')
          : '');
      liste.hidden = false;
      secili = -1;
      return;
    }

    const kategoriBlok = kategoriler.length
      ? '<p class="abt-ara-baslik">Kategoriler</p>' +
        kategoriler
          .slice(0, 3)
          .map((k) => kategoriSatiri(k, q))
          .join('')
      : '';

    const urunBlok = urunler.length
      ? '<p class="abt-ara-baslik">Ürünler</p>' + urunler.map((u) => urunSatiri(u, q)).join('')
      : '';

    liste.innerHTML =
      kategoriBlok +
      urunBlok +
      `<a class="abt-ara-tumu" href="${kok}search?q=${encodeURIComponent(q)}">
         Tüm sonuçları gör
         <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8h9M8.5 4.5L12 8l-3.5 3.5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
       </a>`;
    liste.hidden = false;
    secili = -1;
  }

  const satirlar = () =>
    [...liste.querySelectorAll('.abt-ara-satir, .abt-ara-kategori, .abt-ara-tumu')];

  const isaretle = (yon) => {
    const s = satirlar();
    if (!s.length) return;
    secili = (secili + yon + s.length) % s.length;
    s.forEach((e, i) => e.classList.toggle('abt-ara-secili', i === secili));
    s[secili].scrollIntoView({ block: 'nearest' });
  };

  input.addEventListener('input', () => {
    const q = input.value.trim();
    clearTimeout(zamanlayici);
    if (q.length < 2) return baslangicPaneli() || kapat();

    liste.innerHTML = '<p class="abt-ara-bos">Aranıyor…</p>';
    liste.hidden = false;

    zamanlayici = setTimeout(async () => {
      try {
        bas(await ara(q), q);
      } catch {
        kapat();
      }
    }, 220);
  });

  input.addEventListener('focus', () => {
    const q = input.value.trim();
    if (q.length > 1 && liste.innerHTML) liste.hidden = false;
    else baslangicPaneli();
  });

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      kapat();
      input.blur();
      return;
    }
    if (e.key === 'Enter') {
      if (secili > -1 && !liste.hidden) {
        e.preventDefault();
        satirlar()[secili].click();
        return;
      }
      aramayiKaydet(input.value.trim());
      return;
    }
    if (liste.hidden) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      isaretle(1);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      isaretle(-1);
    }
  });

  liste.addEventListener('click', (e) => {
    if (e.target.closest('a')) aramayiKaydet(input.value.trim());
  });

  document.addEventListener('click', (e) => {
    if (!kap.contains(e.target)) kapat();
  });
})();
